import { render, staticRenderFns } from "./LoginSignupDialog.vue?vue&type=template&id=a6be2cee&scoped=true&"
import script from "./LoginSignupDialog.vue?vue&type=script&lang=ts&"
export * from "./LoginSignupDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LoginSignupDialog.vue?vue&type=style&index=0&id=a6be2cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6be2cee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VDialog,VProgressCircular,VRow})
